var vars = require('./core');

module.exports = vars.createClass('Pie', ['getSegmentsAtEvent']);



// WEBPACK FOOTER //
// ./src/Scripts/react-chartjs/lib/pie.js